<ng-container *ngIf="canViewRoles$ | async">
    <div *ngLet="(roles$ | async) as roles"
         class="ui-folders-default-roles">
        <div *uiContentLoading="roles == null">
            <ui-card-info [icon]="'folder_open'"
                          [message]="'modern_folders_default_roles_explain' | translate">
            </ui-card-info>

            <mat-list dense>
                <mat-list-item *ngFor="let role of roles; let i = index;">
                    <span [matTooltip]="role.tooltip | translate : role.tooltipTranslateParams"
                          [class.is-created]="role.status === 'created'"
                          [attr.data-cy]="'role-'+ i"
                          class="role-label">
                        {{ role.name }}
                    </span>

                    <button *ngIf="role.status == null || role.status === 'pending'"
                            [uiAuthorizeDisable]="'Roles.Create'"
                            [disableIf]="role.status === 'pending'"
                            [spinnerButtonLoading]="role.status === 'pending'"
                            [matTooltip]="'settings_create_role' | translate"
                            [attr.data-cy]="'role-create-'+ i"
                            (click)="create(role)"
                            ui-spinner-button
                            mat-icon-button
                            type="button"
                            color="primary">
                        <mat-icon>add_circle</mat-icon>
                    </button>

                    <button *ngIf="role.status === 'incomplete'"
                            [attr.data-cy]="'role-warn-'+ i"
                            [matTooltip]="'settings_created_role_missing' | translate: { missing: role.missingPermissions }"
                            type="button"
                            color="warn"
                            mat-icon-button>
                        <mat-icon>warning</mat-icon>
                    </button>

                    <button *ngIf="role.status === 'created'"
                            [attr.data-cy]="'role-created-'+ i"
                            [matTooltip]="'settings_created_role' | translate"
                            type="button"
                            color="accent"
                            class="is-valid"
                            mat-icon-button>
                        <mat-icon>check_circle</mat-icon>
                    </button>
                </mat-list-item>
            </mat-list>
        </div>
    </div>
</ng-container>
